import { render, staticRenderFns } from "./PrivilegeEditCompany.vue?vue&type=template&id=7398a2be&scoped=true"
import script from "./PrivilegeEditCompany.vue?vue&type=script&lang=js"
export * from "./PrivilegeEditCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7398a2be",
  null
  
)

export default component.exports